// Extracts an approximate dominant color from an image (data URL or same-origin URL).
export const getDominantColor = (src) =>
  new Promise((resolve) => {
    try {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const size = 40;
        const c = document.createElement("canvas");
        c.width = size;
        c.height = size;
        const ctx = c.getContext("2d");
        ctx.drawImage(img, 0, 0, size, size);
        let data;
        try {
          data = ctx.getImageData(0, 0, size, size).data;
        } catch {
          return resolve(null);
        }
        let r = 0, g = 0, b = 0, n = 0;
        for (let i = 0; i < data.length; i += 4) {
          const a = data[i + 3];
          if (a < 128) continue;
          const rr = data[i], gg = data[i + 1], bb = data[i + 2];
          if (rr > 245 && gg > 245 && bb > 245) continue; // skip near-white bg
          r += rr; g += gg; b += bb; n++;
        }
        if (!n) return resolve("#0f172a");
        r = Math.round(r / n); g = Math.round(g / n); b = Math.round(b / n);
        const hex = "#" + [r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("");
        resolve(hex);
      };
      img.onerror = () => resolve(null);
      img.src = src;
    } catch {
      resolve(null);
    }
  });
